@let businessAccounts = businessAccounts$ | async;
@let businessAccountsLoading = businessAccountsLoading$ | async;
@let businessAccount = selectedBusinessAccount$ | async;

<div class="sidebar">
  @if (isSponsorTenant$ | async) {
    <a class="navbar-brand iris" [routerLink]="['/app/dashboard']">
      <img src="./assets/images/iris-logo.svg" class="navbar-rocket-image img-fluid" [alt]="brand.logoAlt" [title]="brand.logoAlt" />
    </a>
  }

  @if ((isSponsorTenant$ | async) === false) {
    <a class="navbar-brand" [routerLink]="['/app/dashboard']">
      <img [src]="brand.sidebarLogo" class="navbar-rocket-image img-fluid" [alt]="brand.logoAlt" [title]="brand.logoAlt" />
    </a>
  }

  @if (businessAccounts && businessAccounts.length > 1) {
    <div class="mb-5 mx-3">
      <ng-select
        #selectBusinessAccount
        [id]="businessAccountDropdownId"
        [labelForId]="businessAccountDropdownId"
        class="business-account-select"
        [class.with-spinner]="true"
        [items]="businessAccounts ?? []"
        [(ngModel)]="selectedBusinessAccountId"
        [clearable]="false"
        [searchable]="true"
        dropdownPosition="bottom"
        (change)="onBusinessAccountSelectChange($event)"
        bindLabel="name"
        bindValue="id"
        [loading]="businessAccountsLoading ?? true"
        appendTo="body"
        [disabled]="businessAccountsLoading ?? true"
        [placeholder]="''"
      >
        <ng-template ng-label-tmp let-item="item">
          <div class="business-account-option">
            <div class="business-account-status" [ngClass]="'status-' + item['status']"></div>
            <div class="text-truncate">
              <span class="ng-value-label">{{ item['name'] }}</span>
            </div>
          </div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <div class="business-account-option">
            <div class="business-account-status" [ngClass]="'status-' + item['status']"></div>
            <div class="text-truncate">
              <span class="ng-option-label">{{ item['name'] }}</span>
            </div>
          </div>
        </ng-template>
      </ng-select>
    </div>
  } @else {
    <div class="business-profile">
      <div class="business-profile-status-container">
        <div class="business-profile-status"></div>
      </div>
      <div class="business-profile-name">
        {{ businessAccount?.operatingName }}
      </div>
    </div>
  }

  @if (isSponsorTenant$ | async) {
    <div class="menu-items">
      <rkt-table-search placeholder="Search..." (click)="openBusinessAccountListModal()"></rkt-table-search>
    </div>
  }

  <ng-template #menuItemsTmpl let-menuItems="menuItems" let-isSubItem="isSubItem">
    @for (menuItem of menuItems; track menuItem) {
      <div class="menu-items">
        @if (!menuItem.subItems?.length) {
          @if (!menuItem.isExternal) {
            <a
              class="menu-item"
              [class.disabled]="menuItem.notAllowed"
              [class.menu-sub-item]="isSubItem"
              [title]="menuItem.title"
              [class.d-none]="menuItem.hidden"
              [class.active]="isActive(menuItem.href)"
              [routerLink]="menuItem.notAllowed ? null : menuItem.href"
              [target]="menuItem.target ?? '_self'"
              (click)="menuItem.customClick && menuItem.customClick($event)"
            >
              @if (!!menuItem.icon) {
                <rkt-icon class="menu-icon" [name]="menuItem.icon"></rkt-icon>
              }
              <span class="menu-text">{{ menuItem.title }}</span>
            </a>
          }
          @if (menuItem.isExternal) {
            <a
              class="menu-item"
              [class.disabled]="menuItem.notAllowed"
              [class.menu-sub-item]="isSubItem"
              [title]="menuItem.title"
              [class.d-none]="menuItem.hidden"
              [class.active]="isActive(menuItem.href)"
              [href]="menuItem.href"
              [target]="menuItem.target ?? '_self'"
              (click)="menuItem.customClick && menuItem.customClick($event)"
            >
              @if (!!menuItem.icon) {
                <rkt-icon class="menu-icon" [name]="menuItem.icon"></rkt-icon>
              }
              <span class="menu-text">{{ menuItem.title }}</span>
            </a>
          }
        } @else {
          <div
            class="menu-item collapsable"
            [class.active]="hasActiveSubItem(menuItem)"
            [title]="menuItem.title"
            (click)="toggleCollapsableItem(menuItem)"
          >
            <rkt-icon class="menu-icon" [name]="menuItem.icon!"></rkt-icon>
            <span class="menu-text">{{ menuItem.title }}</span>
            <rkt-icon class="menu-toggler" [name]="menuItem.isCollapsed ? 'chevron-down' : 'chevron-up'"></rkt-icon>
          </div>
          @if (!menuItem.isCollapsed) {
            <div class="subitems-block">
              <ng-container *ngTemplateOutlet="menuItemsTmpl; context: { menuItems: menuItem.subItems, isSubItem: true }"></ng-container>
            </div>
          }
        }
      </div>
    }
  </ng-template>

  <ng-template #developerMenuItemsTmpl>
    @if (developerMenuItems.length) {
      <div class="other-menu-container">
        <div class="menu-separator"></div>
        <div class="heading-banner">Developer Tooling</div>
      </div>

      <ng-container *ngTemplateOutlet="menuItemsTmpl; context: { menuItems: developerMenuItems }"></ng-container>
    }
  </ng-template>

  <ng-container *ngTemplateOutlet="menuItemsTmpl; context: { menuItems: menuItems }"></ng-container>

  <ng-container *ngTemplateOutlet="developerMenuItemsTmpl"></ng-container>

  <app-version></app-version>
</div>
